import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';

type Props = {
  showModal: boolean;
  onContinue: () => void;
  onCreate: () => void;
};

export default function CourseNoCertNavAlertModal({ showModal, onContinue, onCreate }: Props) {
  return (
    <Modal
      open={showModal}
      customSize={{
        width: '600px',
        height: 'auto',
        maxHeight: '300px',
        minHeight: '200px',
        maxWidth: 'calc(100vw - 80px)',
      }}
      contentWrapperClassName="padding-24 gap-40"
      onRequestClose={onContinue}
      renderHeaderContent={() => {
        return (
          <Container className="radius-10">
            <Text clamp={2} whiteSpace="wrap" tag="h3" color="var(--gray-100)" className="H3 margin-b-8">
              Certificate not created
            </Text>
          </Container>
        );
      }}
      renderFooterContent={() => {
        return (
          <Container borderRadius="0 0 12px 12px" className="flex fd-row jc-flex-end ai-center">
            <Button design="LocalBttnSecTransp" className="L1 padding-v-8 padding-h-16 margin-r-8" onClick={onContinue}>
              Continue without creating
            </Button>
            <Button
              width="105px"
              className="padding-v-8 padding-h-16 flex jc-center"
              onClick={onCreate}
              backgroundColor={getThemeColorCSSVariable()}
              hoverOpacity={0.8}
            >
              <Text
                color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
                className="L1"
              >
                Create
              </Text>
            </Button>
          </Container>
        );
      }}
    >
      <Container className="overflow-auto" height="100%">
        <Text tag="p" color="var(--gray-300)" className="P1">
          If you leave now, your course will not have a certificate.
          <br />
          You haven't created one yet.
        </Text>
      </Container>
    </Modal>
  );
}
